import type {
    IPrivateMessage,
    IRoomMessage,
    IRoomNotice,
    IShortcodeMessage,
    LogMessageType,
} from "@multimediallc/web-utils/types"

export enum ChatEntityType {
    RoomMessage,
    ShortcodeMessage,
    RoomNotice,
    PmMessage,
    LogMessage,
    AppPanel,
}

export type ChatEntityID = string | number

export type ChatEntityMetadata = {
    derivedTimestamp: number
    timeReceived: number
    entityType: ChatEntityType
    id: ChatEntityID
}

export type ReactRoomMessage = IRoomMessage & Partial<IShortcodeMessage>

export type RoomMessageData = ReactRoomMessage &
    ChatEntityMetadata & { entityType: ChatEntityType.RoomMessage }
export type RoomNoticeData = IRoomNotice &
    ChatEntityMetadata & { entityType: ChatEntityType.RoomNotice }
export type PmData = IPrivateMessage &
    ChatEntityMetadata & { entityType: ChatEntityType.PmMessage }
export type LogMessageData = {
    message: LogMessageType
} & ChatEntityMetadata & { entityType: ChatEntityType.LogMessage }

// TODO CBD-2211 include actual app panel data for react to build app panel component
export type AppPanelData = ChatEntityMetadata & {
    entityType: ChatEntityType.AppPanel
}

export type ChatEntityData =
    | RoomMessageData
    | RoomNoticeData
    | PmData
    | LogMessageData
    | AppPanelData
